<template>
  <header ref="header" class="header">
    <div class="container flex items-center justify-between h-14 md:h-20 py-3 md:py-4">
      <Link :href="route('home')" class="h-full -ml-1 md:ml-0">
        <img class="block h-full pb-[2%]" src="/media/Onlineshop_KM_RGB.svg" alt="DAS DA Kulturmanagement">
      </Link>

      <nav class="space-x-8 hidden md:block">
        <Link
          :href="route('events.index')"
          :class="{ 'text-blue-500': route().current('events.*') }"
          class="font-bold uppercase"
        >Tickets</Link>
        <Link
          :href="route('coupons.index')"
          :class="{ 'text-blue-500': route().current('coupons.*') }"
          class="font-bold uppercase"
        >Abos</Link>
        <!-- <Link
          :href="route('vouchers.card')"
          :class="{ 'text-blue-500': route().current('vouchers.card') }"
          class="font-bold uppercase"
        >DAS DA-Card</Link> -->
        <Link
          :href="route('vouchers.index')"
          :class="{ 'text-blue-500': route().current('vouchers.index|vouchers.show') }"
          class="font-bold uppercase"
        >Gutscheine</Link>
      </nav>

      <button
        aria-label="Menü"
        class="p-2 -m-2 md:hidden"
        @click="menu = !menu"
      >
        <Icon :type="menu ? 'close' : 'bars'" />
      </button>
    </div>
  </header>

  <Modal :show="menu" @close="menu = false" class="z-10">
    <nav class="container pt-24 pb-10 bg-white w-full h-full min-h-screen relative text-right">
      <ul class="space-y-4 text-2xl">
        <li>
          <Link
            :href="route('events.index')"
            :class="{ 'text-blue-500': route().current('events.*') }"
            class="font-bold uppercase"
          >Tickets</Link>
        </li>
        <li>
          <Link
            :href="route('coupons.index')"
            :class="{ 'text-blue-500': route().current('coupons.*') }"
            class="font-bold uppercase"
          >Abos</Link>
        </li>
        <!-- <li>
          <Link
            :href="route('vouchers.card')"
            :class="{ 'text-blue-500': route().current('vouchers.card') }"
            class="font-bold uppercase"
          >DAS DA-Card</Link>
        </li> -->
        <li>
          <Link
            :href="route('vouchers.index')"
            :class="{ 'text-blue-500': route().current('vouchers.index|vouchers.show') }"
            class="font-bold uppercase"
          >Gutscheine</Link>
        </li>
        <li>
          <Link
            :href="route('pages.faq')"
            :class="{ 'text-blue-500': route().current('pages.faq') }"
            class="font-bold uppercase"
          >FAQ</Link>
        </li>
      </ul>

      <div class="text-blue-500 mt-12 mb-4">
        Hilfe &amp; Kontakt
      </div>
      <ul class="space-y-1">
        <li>DAS DA-Theaterkasse</li>
        <li>Di-Fr 9:00-15:00 Uhr</li>
        <li></li>
        <li><a href="tel:0049241161688" class="underline">0241 161688</a></li>
        <li><a href="mailto:shop@dasda.de" class="underline">shop@dasda.de</a></li>
      </ul>
    </nav>
  </Modal>

  <main class="pt-14 md:pt-20">
    <slot name="default" />
  </main>

  <footer class="bg-gray-100 tracking-wider overflow-hidden">
    <div class="container">

      <div class="lg:flex justify-between pb-10 pt-20 lg:pb-16 text-sm">
        <div class="md:flex items-center">
          <img class="w-[180px] mr-4" src="/media/DDT_Logo-21.svg" alt="DAS DA Theater">
          <p class="text-gray-600 max-w-xl flex-1 mt-4 md:mt-0">
            Schauspiel, Musicals, Theaterdinner, Open-Air-Events und mehr: Das Angebot des DAS DA THEATERS ist vielseitig. Als größtes Privattheater der StädteRegion Aachen bringen wir seit 1987 moderne Inszenierungen, bekannte Klassiker und Kinderstücke auf die Bühne.
          </p>
        </div>
        <div class="flex self-start space-x-2 mt-6 lg:mt-0">
          <a href="https://www.facebook.com/dasda.aachen/" target="_blank" rel="nofollow" class="text-blue-500" title="facebook">
            <Icon type="facebook" size="8" />
          </a>
          <a href="https://www.instagram.com/dasdatheater/" target="_blank"  rel="nofollow" class="text-blue-500" title="instagram">
            <Icon type="instagram" size="8" />
          </a>
          <a href="https://www.youtube.com/channel/UC7kIRtOK5mNVD00N9PgM2Ag" target="_blank"  rel="nofollow" class="text-blue-500" title="youtube">
            <Icon type="youtube" size="8" />
          </a>
        </div>
      </div>

      <div class="py-10 border-t border-gray-300 text-gray-700 text-sm">
        <div class="grid gap-10 max-w-2xl sm:grid-cols-2 lg:max-w-full lg:flex lg:gap-0 lg:space-x-20">

          <div>
            <div class="text-blue-500 pb-4">Hilfe &amp; Kontakt</div>
            <ul class="space-y-2">
              <li>DAS DA-Theaterkasse</li>
              <li>Di-Fr 9:00-15:00 Uhr</li>
              <li>0241 161688</li>
              <li><a href="mailto:shop@dasda.de" class="underline">shop@dasda.de</a></li>
            </ul>
          </div>

          <div>
            <div class="text-blue-500 pb-4">Service</div>
            <ul class="space-y-2">
              <li>
                <Link :href="route('pages.informations')" class="underline">Infos zu Tickets, Abos &amp; Gutscheinen</Link>
              </li>
              <li>
                <Link :href="route('pages.shipping-and-payment')" class="underline">Versand &amp; Zahlung</Link>
              </li>
              <li>
                <Link :href="route('vouchers.credit')" class="underline">Guthaben Gutschein</Link>
              </li>
              <li>
                <Link :href="route('pages.faq')" class="underline">FAQ</Link>
              </li>
            </ul>
          </div>

          <div>
            <div class="text-blue-500 pb-4">Rechtliches</div>
            <ul class="space-y-2">
              <li>
                <Link :href="route('pages.terms-and-conditions')" class="underline">AGB</Link>
              </li>
              <li>
                <Link :href="route('pages.right-of-withdrawal')" class="underline">Widerrufsbelehrung</Link>
              </li>
              <li>
                <Link :href="route('pages.data-protection')" class="underline">Datenschutzerklärung</Link>
              </li>
              <li>
                <Link :href="route('pages.accessibility')" class="underline">Barrierefreiheit</Link>
              </li>
              <li>
                <Link :href="route('pages.imprint')" class="underline">Impressum</Link>
              </li>
            </ul>
          </div>

          <div>
            <div class="text-blue-500 pb-4">Sicher zahlen mit</div>
            <ul class="space-y-2">
              <li>
                PayPal
              </li>
              <li>
                Kreditkarte
              </li>
              <li>
                SOFORT Überweisung
              </li>
              <li>
                KLARNA Rechnungskauf
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="md:flex justify-between py-10 border-t border-gray-300 text-sm text-gray-700">
        <div>Onlineshop der DAS DA Kulturmanagement GmbH</div>
        <div class="text-gray-600">© {{ year }} DAS DA THEATER</div>
      </div>

    </div>
  </footer>
</template>

<script>
import Icon from 'Web/Shared/Icon.vue';
import Modal from 'Web/Shared/Modal.vue';
import Link from 'Web/Shared/Link.vue';
import header from '@/helpers/header';
import { nextTick, onMounted, onUnmounted, reactive, toRefs, watch, watchEffect } from 'vue';

export default {
  inheritAttrs: false,
  components: {
    Icon,
    Modal,
    Link,
  },
  setup() {
    const state = reactive({
      header: null,
      menu: false,
    });

    let head;

    function show() {
      state.header.style.transition = 'none';
      nextTick(() => {
        head.show();
        nextTick(() => state.header.style.transition = null);
      });
    }

    function onNavigate() {
      state.menu = false;
      show();
    }

    function onSuccess() {
      state.menu = false;
      nextTick(() => window.scrollY === 0 && show());
    }

    watch(() => state.menu, () => {
      if (state.menu) {
        state.header.style.boxShadow = 'none';
        head.disable();
        head.show();
      } else {
        state.header.style.boxShadow = null;
        head.enable();
      }
    });

    onMounted(() => {
      head = header(state.header);
      document.addEventListener('inertia:navigate', onNavigate);
      document.addEventListener('inertia:success', onSuccess);
    });

    onUnmounted(() => {
      document.removeEventListener('inertia:navigate', onNavigate);
      document.removeEventListener('inertia:success', onSuccess);
      head.destroy();
    });

    const year = new Date().getFullYear();

    return {
      ...toRefs(state),
      year,
    }
  }
}
</script>
